import { getInstanceId } from '@va/dashboard/selectors/app';
import { getPreviousGlobalFilter, getStepFilter } from '@va/dashboard/selectors/ui';
import { PeriodFilter } from '@va/types/time';
import { Moment } from 'moment';
import { useSelector } from 'react-redux';

export const usePreviousPeriodFilter = <T extends boolean = true>(keepOffset = true, convertToIso: T = true as T) => {
  // TODO Important handle install date
  const { period: unit } = useSelector(getStepFilter);
  const { from, until } = useSelector(getPreviousGlobalFilter);
  const websiteId = useSelector(getInstanceId);

  return {
    from: convertToIso ? from.toISOString(keepOffset) : from,
    until: convertToIso ? until.toISOString(keepOffset) : until,
    unit,
    websiteId,
  } as PeriodFilter<T extends true ? string : Moment>;
};
